import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Features() {
  return (
    <section
      id="features"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <h2 className="text-9 fw-600 text-center">Funcionalidades</h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-5">
          O Pelada+ foi criado para tornar a organização das suas partidas mais prática, justa e divertida.<br />Veja o que você pode fazer com o app.
        </p>
        <div className="row">
          <div className="col-lg-4 align-self-center">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-user" />
                  </div>
                  <h3>Cadastre os jogadores </h3>
                  <p>
                    Avalie cada um em critérios como velocidade, movimentação e fase atual, garantindo um equilíbrio real na hora de dividir os times.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-camera" />
                  </div>
                  <h3>Adicione fotos</h3>
                  <p>
                    Deixe tudo mais personalizado e divertido colocando as fotos dos jogadores.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box featured-box-reverse-xl style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-futbol" />
                  </div>
                  <h3>Campinho</h3>
                  <p>
                    Visualize os times organizados em um campinho, como uma escalação real, facilitando a apresentação antes do jogo começar.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center mb-4 mb-xl-0">
            <img
              alt=""
              src="images/app-showcase-feature.png"
              className="img-fluid"
            />
          </div>
          <div className="col-lg-4 align-self-center">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-book" />
                  </div>
                  <h3>Estatísticas*</h3>
                  <p>
                    Cadastre estatísticas dos jogos, como gols, assistências, presenças e desempenho geral.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-users" />
                  </div>
                  <h3>Múltiplos Grupos*</h3>
                  <p>
                    Gerencie vários grupos de pelada, ideal para quem joga com turmas diferentes ao longo da semana.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-lg-12">
                <div className="featured-box style-3 mb-5">
                  <div className="featured-box-icon bg-body-secondary rounded-circle">
                    <i className="fas fa-dollar-sign" />
                  </div>
                  <h3>Baixo Custo</h3>
                  <p>
                    E o melhor: tudo isso por um valor anual acessível — menos do que o preço de uma bola nova. Com a versão premium, você transforma a organização da pelada com praticidade e muito custo-benefício.
                  </p>
                  
                  <small>* Somente na versão Premium.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
